module.exports = __webpack_public_path__ + "img/book-btn03.d8d123de.png";